module.exports = __webpack_public_path__ + "static/CircularPro-Medium.e65abdda.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Medium.ttf
// module id = 730
// module chunks = 168707334958949